import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ModalApp from "../ModalApp";
import { FormNewCard } from "../FormCard";
import CardAddressForm from "./CardAddressForm";
import CardStepsHeader from "./CardStepsHeader";
import { StyledTitle } from "../FormCard/styles";

export default function AddCardModal({
  cardMgmt,
  cards,
  isMyAccountPage = false,
}) {
  const [step, setStep] = useState("card");
  // Fixa se o modal usa o fluxo de steps quando ele abre. Assim o header e o
  // step não somem quando `needsAddress` vira false após salvar o endereço.
  const [useSteps, setUseSteps] = useState(false);

  useEffect(() => {
    if (cardMgmt.boxNewCard) {
      setUseSteps(cardMgmt.needsAddress);
      setStep(cardMgmt.needsAddress ? "address" : "card");
    }
  }, [cardMgmt.boxNewCard]);

  async function handleConfirmAddress(payload) {
    await cardMgmt.saveNewAddress(payload);
    setStep("card");
  }

  return (
    <ModalApp
      show={cardMgmt.boxNewCard}
      handleModal={cardMgmt.closeAddCardModal}
      desktopSize="medium"
    >
      {useSteps && (
        <>
          <div className="mx-4">
            <StyledTitle
              className="font-wl-600 text-mlg"
              style={{ textAlign: "left" }}
            >
              Preencha os dados para <br /> adicionar seu cartão
            </StyledTitle>
          </div>
          <CardStepsHeader currentStep={step} />
        </>
      )}

      {useSteps && step === "address" ? (
        <CardAddressForm
          onConfirm={handleConfirmAddress}
          isSaving={cardMgmt.isSavingAddress}
        />
      ) : (
        <FormNewCard
          saveNewCard={cardMgmt.saveNewCard}
          onCancel={cardMgmt.closeAddCardModal}
          cards={cards}
          isMyAccountPage={isMyAccountPage}
          Loading={cardMgmt.isLoading}
          hideTitle={useSteps}
        />
      )}
    </ModalApp>
  );
}

AddCardModal.propTypes = {
  cardMgmt: PropTypes.shape({
    boxNewCard: PropTypes.bool,
    openAddCardModal: PropTypes.func,
    closeAddCardModal: PropTypes.func,
    saveNewCard: PropTypes.func,
    saveNewAddress: PropTypes.func,
    onClickDelCard: PropTypes.func,
    isLoading: PropTypes.bool,
    needsAddress: PropTypes.bool,
    isSavingAddress: PropTypes.bool,
  }).isRequired,
  cards: PropTypes.array,
  isMyAccountPage: PropTypes.bool,
};
